import { Auth } from 'aws-amplify';

import UserBase from '../views/User/Layout.vue';
import Dashboard from '../views/User/Dashboard.vue';
import Members from '../views/User/Members/List.vue';
import Files from '../views/User/Files/List.vue';
import Ads from '../views/User/Ads/List.vue';
import Ad from '../views/User/Ads/Details.vue';
import Newsletter from '../views/User/Newsletter/List.vue';
import Articles from '../views/User/Articles/List.vue';
import Campaigns from '../views/User/Campaigns/List.vue';
import CampaignDetails from '../views/User/Campaigns/Details.vue';
import CampaignStats from '../views/User/Campaigns/CampaignStats.vue';
import NewCampaignArticle from '../views/User/Campaigns/NewCampaignArticle.vue';
import EditCampaignArticle from '../views/User/Campaigns/EditCampaignArticle.vue';
import Press from '../views/User/Press/List.vue';
import Events from '../views/User/Events/List.vue';
import NewArticle from '../views/User/Articles/New.vue';
import EditArticle from '../views/User/Articles/Edit.vue';
import Help from '../views/User/Help/Index.vue';

function loggedIn(to: any, from: any, next: any) {
  Auth.currentAuthenticatedUser().then(() => {
    next();
  }).catch(() => {
    next({name: 'GuestBase'});
  });
}

export default [
  {
    path: '/ua',
    name: 'UserBase',
    component: UserBase,
    beforeEnter: loggedIn,
    redirect: {name: 'Dashboard'},
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'mitglieder',
        name: 'Members',
        component: Members,
      },
      {
        path: 'dateiverwaltung',
        name: 'Files',
        component: Files,
      },
      {
        path: 'ads/:id',
        props: true,
        name: 'Ad',
        component: Ad,
      },
      {
        path: 'ads',
        name: 'Ads',
        component: Ads,
        meta: {title: 'Angebote'},
      },
      {
        path: 'newsletter',
        name: 'Newsletter',
        component: Newsletter,
        meta: {title: 'Newsletterabonnenten'},
      },
      {
        path: 'articles',
        name: 'Articles',
        component: Articles,
        meta: {title: 'Artikel (alt)'},
      },
      {
        path: 'press',
        name: 'Press',
        component: Press,
        meta: {title: 'Presse'},
      },
      {
        path: 'events',
        name: 'Events',
        component: Events,
        meta: {title: 'Netzwerktreffen'},
      },
      {
        path: 'kampagnen',
        name: 'Campaigns',
        component: Campaigns,
        meta: {title: 'Kampagnen'},
      },
      {
        path: 'kampagne/:id',
        props: true,
        name: 'CampaignDetails',
        component: CampaignDetails,
        meta: {title: 'Kampagne'},
      },
      {
        path: 'kampagne/:id/statistik',
        props: true,
        name: 'CampaignStats',
        component: CampaignStats,
        meta: {title: 'Kampagnen Statistik'},
      },
      {
        path: 'kampagne/:id/artikel/neu',
        props: true,
        name: 'NewCampaignArticle',
        component: NewCampaignArticle,
        meta: {title: 'Neuer Artikel'},
      },
      {
        path: 'kampagne/:id/artikel/:articleId',
        props: true,
        name: 'EditCampaignArticle',
        component: EditCampaignArticle,
        meta: {title: 'Artikel bearbeiten'},
      },
      {
        path: 'articles/new',
        name: 'NewArticle',
        component: NewArticle,
        meta: {title: 'Neuen Artikel erstellen'},
      },
      {
        path: 'articles/:id',
        props: true,
        name: 'EditArticle',
        component: EditArticle,
        meta: {title: 'Artikel bearbeiten'},
      },
      {
        path: 'help',
        props: true,
        name: 'Help',
        component: Help,
        meta: {title: 'Hilfe'},
      },
    ],
  },
];
